(function ($) {
    $(document).ready(function () {

        //Hero Slider
        function heroAnimation() {
            $(this).find(".slick-slide").removeClass('animate');
            $(this).find(".slick-current").addClass('animate');
            var currentSlide = $(this).find('.slick-slide.slick-current');
            var player = currentSlide.find("iframe").get(0);
            if (player) {
                setTimeout(function () {
                    player.contentWindow.postMessage(JSON.stringify({
                        "method": "play",
                        "value": 1
                    }), "*");

                }, 2000);
            }
        }


        $(".hero__slider")
            .on('init', heroAnimation)
            .on('afterChange', heroAnimation);


        $(".hero__slider").slick({
            prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
            nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>'
        });


 


        setTimeout(function () {
            $(".new-boat__title").addClass('fade-out');
        }, 3000);


        //Range slider 
        //992px
        $(".range-slider").slick({
            arrows: false,
            draggable: false,
            infinite: false,
            swipe: false,
            speed: 600,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        draggable: true,
                        swipe: true
                    }
                }
            ]

        });

        $(".yacht-range__slide-navigation-item").on('click', function () {
            $(this).parents(".yacht-range__section")
                .children(".range-slider")
                .slick('slickGoTo', $(this).attr('data-slide-target'));
        });

        $('.range-slider').on('afterChange', function () {
            let $this = $(this);

            $(this).parents(".yacht-range__section")
                .find(".yacht-range__slide-navigation-item")
                .each(function (index) {
                    if (index != $this.slick('slickCurrentSlide')) {
                        $(this).removeClass("active");
                    }
                    else {
                        $(this).addClass("active");
                    }
                })
        });

        //Events Slider
        $(window).on('load resize', function () {
            alignEventSliderArrow();
        });

        function alignEventSliderArrow() {
            var toppos = ($('.events-slider .slick-active').find("img").height() / 2);
            $('.events-slider .slick-arrow').css('top', (toppos - 9) + 'px');
        }
        $(".events-slider").slick({
            prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
            nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>',
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                    }
                }
            ]
        }).on('reInit', function (event) {
            alignEventSliderArrow();
        })
            .on('afterChange', function (event) {
                alignEventSliderArrow();
            }).trigger('afterChange');;

        let gallerySettings = {
            infinite: false,
            speed: 600,
            prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
            nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>'
        }

        // video slider
        if ($(".video-carousel").length) {

            function postMessageToPlayer(player, command) {
                console.log('postMessageToPlayer', command);
                if (player == null || command == null) return;
                player.contentWindow.postMessage(JSON.stringify(command), "*");
            }

            $(".video-carousel").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: '10%',
                swipeToSlide: true,
                centerMode: true,
                focusOnSelect: true,
                prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
                nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>',
            });
            $('.video-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var current = $(slick.$slides[currentSlide]);
                var next = $(slick.$slides[nextSlide]);
                var lastPlayer = current[0].querySelector('iframe');
                var player = next[0].querySelector('iframe');

                if (lastPlayer !== null) {
                    if (current.hasClass('video-youtube')) {
                        console.log('YOUTUBE POST MESSAGE');
                        postMessageToPlayer(lastPlayer, {
                            "event": "command",
                            "func": "pauseVideo"
                        });
                    }
                    if (current.hasClass('video-vimeo')) {
                        console.log('VIMEO');
                        postMessageToPlayer(lastPlayer, {
                            "method": "pause"
                        });
                    }
                }
                if (player !== null) {
                    if (next.hasClass('video-youtube')) {
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "mute"
                        });
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "playVideo"
                        });
                    }
                    if (current.hasClass('video-vimeo')) {
                        postMessageToPlayer(player, {
                            "method": "play"
                        });
                    }
                }
            });
        }


        //Gallery Slider
        if ($(".gallery-slider .load-image").length) {
            // on init - delayed 
            /*
            $('.gallery-slider').on('init', function () {
                var slider = $(this);
                setTimeout(function () {
                    slider.find('.load-image').each(function () {
                        $(this).attr("src", $(this).data('image'));
                    });
                }, 1000);
            });
            */
            // before next
            $('.gallery-slider').on("beforeChange", function (event, { slideCount: count }, currentSlide, nextSlide) {
                var nextPanel = $('[data-slick-index=' + nextSlide + ']');
                nextPanel.find('.load-image').each(function () {
                    $(this).attr("src", $(this).data('image'));
                });
            });
        }
        $(".gallery-slider").slick(gallerySettings);


        //Lightbox Gallery Slider    
        $(".lightbox-gallery-slider").slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            swipeToSlide: true,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
            nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        // handle swipes/clicks
        $('.lightbox-gallery-slider').on('click', '.slick-list', function (e) {
            //console.log('.slick-list',e); 
            if (e.type === 'click') {
                var slideClicked = $(this).find(".slick-center a.expand-btn").data("fancybox-index")
                //console.log('trigger click',  slideClicked); 
                $('.lightbox-gallery-links').find('div#lightbox-gallery-img-' + slideClicked).trigger('click');
            }
        });


        //Charter Gallery
        $('.charter-slider__nav').slick({
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });

        $("div[class*='charter__gallery-nav']").each(function () {
            var index = $(this).attr('data-index');


            $('.charter__gallery--' + index).slick('slickSetOption', 'asNavFor', '.charter__gallery-nav--' + index);
            $('.charter__gallery-nav--' + index).slick('slickSetOption', 'asNavFor', '.charter__gallery--' + index);
        });

        //Interior Gallery Slider
        $(".gallery-slider--interior").slick(gallerySettings);
        $('.gallery-slider--interior').slick('slickSetOption', 'asNavFor', '.gallery-slider-nav--interior');

        $('.gallery-slider-nav--interior').slick({
            asNavFor: ".gallery-slider--interior",
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: true
        });

        //Exterior Gallery Slider
        $(".gallery-slider--exterior").slick(gallerySettings);
        $('.gallery-slider--exterior').slick('slickSetOption', 'asNavFor', '.gallery-slider-nav--exterior');

        $('.gallery-slider-nav--exterior').slick({
            asNavFor: ".gallery-slider--exterior",
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: true
        });

        //Combined slider
        $(".gallery-slider--combined").slick('slickSetOption', 'asNavFor', '.gallery-slider__nav--combined');
        $(".gallery-slider__nav--combined").slick({
            asNavFor: ".gallery-slider--combined",
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: true
        })

        $(".sistership").each(function () {
            let name = $(this).attr('data-tab');
            let selector = '.sistership-slider__nav--' + name;

            $(".sistership-slider", $(this)).slick(gallerySettings);
            $(".sistership-slider", $(this)).slick('slickSetOption', 'asNavFor', selector);

            $(selector).slick({
                asNavFor: ".sistership-" + name,
                arrows: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                centerMode: true,
                focusOnSelect: true,
                infinite: true
            })

        });

        $(".other-boats").slick({
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: true,
            infinite: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                    }
                }
            ]
        });

        $('.history-slider').slick({
            prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
            nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>',
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: true,
            infinite: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

         //Bluegame Gallery Slider    
         $(".bluegame-boat-gallery .main").slick({
            prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
            nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>',
            lazyLoad: 'ondemand',
            slidesToShow: 2,
            slidesToScroll: 2,
            autoplay: false,
            dots: false,
            arrows: true,
            draggable: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });

        // bluegame video slider
                // VIDEO SLDIER

                if ($('.bluegame-boat-video-slider').length) {

                    $('.hero').waypoint({
                        handler: function (direction) {
                            $('.bluegame-boat-video-slider iframe').each(function() {
                                if( $( this ).attr('src') == ''){
                                    $( this ).attr('src', $(this).data('src'))
                                }                                
                              });
                        },
                        offset: -100
                    })


                    // video control function
                    function postMessageToPlayer(player, command) {
                        //console.log('postMessageToPlayer', command);
                        if (player == null || command == null) return;
                        player.contentWindow.postMessage(JSON.stringify(command), "*");
                    }
        
                    // video waypoints
                    new Waypoint.Inview({
                        element: $('.bluegame-boat-video-slider'),
                        enter: function (direction) {
                           // console.log('inview enter');
                            var current = $('.bluegame-boat-video-slider .slick-track').find(' .slick-slide.slick-current .bluegame-boat-media');
                            var player = current[0].querySelector('iframe');
                            if (player !== null) {                        
                                if (current.hasClass('bluegame-boat-media-youtube')) {
                                    postMessageToPlayer(player, {
                                        "event": "command",
                                        "func": "mute"
                                    });
                                    postMessageToPlayer(player, {
                                        "event": "command",
                                        "func": "playVideo"
                                    });
                                }
                                if (current.hasClass('bluegame-boat-media-vimeo')) {
                                    postMessageToPlayer(player, {
                                        "method": "play"
                                    });
                                }
                            }
                        },
                        exited: function (direction) {
                            //console.log('inview exit');
                            //var current = $('.bluegame-boat-video-slider').find(' .slick-slide.slick-current');
                            var current = $('.bluegame-boat-video-slider .slick-track').find(' .slick-slide.slick-current .bluegame-boat-media');
                            var player = current[0].querySelector('iframe');
                            if (player !== null) {
                                if (current.hasClass('bluegame-boat-media-youtube')) {
                                    postMessageToPlayer(player, {
                                        "event": "command",
                                        "func": "pauseVideo"
                                    });
                                }
                                if (current.hasClass('bluegame-boat-media-vimeo')) {
                                    postMessageToPlayer(player, {
                                        "method": "pause"
                                    });
                                }
                            }
        
                        }
                    });
        
                    // video slider
                    $('.bluegame-boat-video-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                        var current = $(slick.$slides[currentSlide]);
                        var next = $(slick.$slides[nextSlide]);
                        var lastPlayer = current[0].querySelector('iframe');
                        var player = next[0].querySelector('iframe');
        
                        if (lastPlayer !== null) {
        
                            if (current.find('div.bluegame-boat-media-youtube').length > 0) {
                                postMessageToPlayer(lastPlayer, {
                                    "event": "command",
                                    "func": "pauseVideo"
                                });
                            }
                            if (current.find('div.bluegame-boat-media-vimeo').length > 0) {
                                postMessageToPlayer(lastPlayer, {
                                    "method": "pause"
                                });
                            }
                        }
                        if (player !== null) {
                            if (next.find('div.bluegame-boat-media-youtube').length > 0) {
                                postMessageToPlayer(player, {
                                    "event": "command",
                                    "func": "playVideo"
                                });
                            }
                            if (next.find('div.bluegame-boat-media-vimeo').length > 0) {
                                postMessageToPlayer(player, {
                                    "method": "play"
                                });
                            }
                        }
                    });
        
                    $('.bluegame-boat-video-slider').slick({
                        
            prevArrow: '<i class="fa-solid fa-chevron-left slick-prev"></i>',
            nextArrow: '<i class="fa-solid fa-chevron-right slick-next"></i>',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        draggable: true,
                        dots: true,
                        arrows: true,
                        fade: false,
                        adaptiveHeight: false,
                        centerMode: true,
                        centerPadding: '8%',
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 992,
                                settings: {
                                    centerPadding: '4%',
                                }
                            }
                        ]
                    });
        
                }
        


    })
})(jQuery);